
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import * as actions from '../../../actions/device.Action';
import ReadComponent from './read.component';

class Read extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            selectedUser: null,
            isCreateModelVisible: false,
            isUpdateModelVisible: false
        }
    }

    componentDidMount() {
        this.onFetchData();
    }

    onCreate = () => {
        this.setState({ isCreateModelVisible: true });
    }

    onUpdate = (user) => {
        this.setState({ selectedUser: user, isUpdateModelVisible: true });
    }

    onDelete = (id) => {
        fetch(`https://60fbca4591156a0017b4c8a7.mockapi.io/fakeData/${id}`, {
            method: 'DELETE',
        })
            .then(() => {
                this.onFetchData();
            });
    }

    onCreatePopupClose = () => {
        this.setState({ isCreateModelVisible: false });
        this.onFetchData();
    }

    onUpdatePopupClose = () => {
        this.setState({ isUpdateModelVisible: false });
        this.onFetchData();
    }

    onFetchData = () => {
        fetch(`https://60fbca4591156a0017b4c8a7.mockapi.io/fakeData`)
            .then((res) => res.json())
            .then((data) => {
                this.setState({ users: data });
            });
    }

    render() {
        const { users } = this.state;

        return (
            <ReadComponent
                {...{
                    users,
                    selectedUser: this.state.selectedUser,
                    isCreateModelVisible: this.state.isCreateModelVisible,
                    isUpdateModelVisible: this.state.isUpdateModelVisible
                }}
                onCreate={this.onCreate.bind(this)}
                onUpdate={this.onUpdate.bind(this)}
                onDelete={this.onDelete.bind(this)}
                onCreatePopupClose={this.onCreatePopupClose.bind(this)}
                onUpdatePopupClose={this.onUpdatePopupClose.bind(this)} />
        );
    }
}

function mapStateToProps(state) {
    return {
        device: state.deviceReducer.device
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

Read.displayName = 'Read';

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Read));